import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MediaLibraryDialog } from '../../dialog/library/component';

@Component({
  standalone: false,
  selector: 'app-media-dev-screen',
  templateUrl: './template.html',
  styleUrl: './style.scss',
})
export class MediaDevScreen {
  imageAId = '0c2df953-7d9d-4670-b209-845b4135d415';

  form = new FormGroup({
    image: new FormControl<string>(undefined, Validators.required),
    imageA: new FormControl<string>(this.imageAId, Validators.required),
  });

  constructor(private dialog: MatDialog) {}

  openMediaLibraryDialog() {
    const dialogRef = this.dialog.open(MediaLibraryDialog, {
      width: '1000px',
      maxHeight: '90vh',
    });

    dialogRef.afterClosed().subscribe((imageId: string) => {
      console.log(imageId);
    });
  }
}
